import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../context/app.context";

const HashRedirects = () => {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { resetHistory } = useContext(AppContext);

  useEffect(() => {
    // Redirect old check-in hash URL to new BrowserRouter URL
    const match = hash.match(/#\/service\/lighthouse\/check-in\/(.*?)$/);
    if (match?.[1]) {
      navigate("/book/check-in/" + match[1]);
      resetHistory();
    }
  }, [hash, navigate]);

  return null;
};

export default HashRedirects;
